import { createReducer } from '@reduxjs/toolkit'
import { setFetchingInfoLoaderIsShown } from '../actions/graphic'

interface GraphicReducer {
    fetchingInfoLoaderIsShown: boolean
}

const initialState: GraphicReducer = {
    fetchingInfoLoaderIsShown: false,
}

const graphicReducer = createReducer<GraphicReducer>(initialState, (builder) => {
    builder.addCase(setFetchingInfoLoaderIsShown, (state, action) => {
        state.fetchingInfoLoaderIsShown = action.payload
    })
})

export default graphicReducer
